import React from 'react';
import PropTypes from 'prop-types';

import classes from './LandingMenu.css';
import logo from '../../assets/images/motor-data-icon.png';
import LandingMenuItems from './LandingManuItems/LandingMenuItems';

const landingMenu = props => {
  const { language } = props;
  return (
    <div className={classes.LandingMenu}>
      <div className={classes.LogoWrapper}>
        <img src={logo} alt="Schneider Electric Logo" />
      </div>
      <LandingMenuItems language={language} />
    </div>
  );
};

landingMenu.propTypes = {
  language: PropTypes.string.isRequired
};

export default landingMenu;
